export default __webpack_public_path__ + "static/media/icons-slip-48-px.ecee671c.svg";